import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationBaseFinanceAttributions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTIONS,
		options
	)
}

function _getRegulationBaseFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTION,
		options
	)
}

function _createRegulationBaseFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].CREATE_REGULATION_BASE_FINANCE_ATTRIBUTION,
		options
	)
}

function _putRegulationBaseFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PUT_REGULATION_BASE_FINANCE_ATTRIBUTION,
		options
	)
}

function _patchRegulationBaseFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PATCH_REGULATION_BASE_FINANCE_ATTRIBUTION,
		options
	)
}

function _deleteRegulationBaseFinanceAttribution(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,
		ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].DELETE_REGULATION_BASE_FINANCE_ATTRIBUTION,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTIONS]: _getRegulationBaseFinanceAttributions,

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTION]: _getRegulationBaseFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].CREATE_REGULATION_BASE_FINANCE_ATTRIBUTION]: _createRegulationBaseFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PUT_REGULATION_BASE_FINANCE_ATTRIBUTION]: _putRegulationBaseFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PATCH_REGULATION_BASE_FINANCE_ATTRIBUTION]: _patchRegulationBaseFinanceAttribution,

	[ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].DELETE_REGULATION_BASE_FINANCE_ATTRIBUTION]: _deleteRegulationBaseFinanceAttribution,
}
